'use client';

import { PrivacyPolicyPage } from 'client/modules/terms/pages/privacy-policy/PrivacyPolicePage';

export default PrivacyPolicyPage;
